export enum DoctorType {
    HOSPITAL = 'Regular Doctor',
    FIRST_AID = 'First Aid'
}

export enum DoctorTitles {
    CERTIFIED_FIRST_AID = 'Certified First Aid',
    REGISTERED_NURSE = 'Registered Nurse',
    MEDICAL_DOCTOR = 'Medical Doctor'
}

export class Doctor {
    id: string = '';
    first_name: string = '';
    last_name: string = '';
    email: string = '';
    user_id: string = '';
    locations?: any[] = [];
    profile_image?: string = '';
    status: boolean;
    additional_info: string = '';
    phone?: string = '';
    created_at?: number;
}